import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ChangePassword() {
  const { setMustChange, logout } = useAuth();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [rep, setRep] = useState("");
  const inp = "w-full border border-[#dcd5ce] bg-white px-4 py-3 text-sm outline-none focus:border-[#c5a059]";

  const submit = async (e) => {
    e.preventDefault();
    if (nw !== rep) return toast.error("Las contraseñas no coinciden");
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Contraseña actualizada");
      setMustChange(false);
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div data-testid="change-password-page" className="flex min-h-screen items-center justify-center px-6">
      <form onSubmit={submit} className="card-nilo w-full max-w-md space-y-4 p-10">
        <p className="label-xs">Seguridad</p>
        <h1 className="text-3xl">Cambio de contraseña obligatorio</h1>
        <p className="text-sm text-[#5e5a56]">Por tu seguridad, definí una contraseña personal antes de continuar.</p>
        <input data-testid="cp-current" required type="password" placeholder="Contraseña actual (tu DNI)" className={inp} value={cur} onChange={(e) => setCur(e.target.value)} />
        <input data-testid="cp-new" required type="password" placeholder="Nueva contraseña" className={inp} value={nw} onChange={(e) => setNw(e.target.value)} />
        <input data-testid="cp-repeat" required type="password" placeholder="Repetir nueva contraseña" className={inp} value={rep} onChange={(e) => setRep(e.target.value)} />
        <button data-testid="cp-submit" className="btn-gold w-full rounded-full px-8 py-3.5 text-xs uppercase tracking-[0.18em]">Guardar y continuar</button>
        <button type="button" onClick={logout} className="w-full text-xs text-[#8b7355] underline">Cerrar sesión</button>
      </form>
    </div>
  );
}
